export const getApplicationFlags = (loan) => {
  const isOcm = loan.channel === 'OCM-WEB';
  const isOcmOrUpgrade = isOcm || INCREASE_APP;

  return { isOcmOrUpgrade };
};
